import { CommonSearchInput } from 'components/common/form/search';
import { DELIVERY_TYPES } from 'lib_ts/enums/pitches.enums';
import { useVideosStore } from 'stores/use-videos-store';

interface IProps {
  onChange?: () => void;
}

export const VideosFilterDelivery = (props: IProps) => {
  const filter = useVideosStore((s) => s.filter);

  return (
    <CommonSearchInput
      id="video-delivery"
      placeholder="videos.pitch-delivery-type"
      options={DELIVERY_TYPES}
      values={filter.delivery}
      onChange={(v) => {
        useVideosStore.getState().mergeFilter({ delivery: v });
        props.onChange?.();
      }}
      multiple
      optional
    />
  );
};
